var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{staticClass:"custom-content-container pt-0",attrs:{"cols":"12"}},[_c('v-row',[_c('v-col',{attrs:{"md":"6","offset-md":"3"}},[_c('v-sheet',{staticClass:"width-100 text-right",style:({
              'background-color': _vm.engineer.color,
              height: '300px',
              'border-radius': '10px',
            }),attrs:{"elevation":"15","height":"100","width":"100"}})],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }